import React from "react";
import { cn } from "@/lib/utils";

interface RichTextRendererProps extends React.HTMLAttributes<HTMLDivElement> {
    html: string | undefined | null;
    /**
     * If true, forces inline behavior by resetting paragraph margins and display.
     * Useful for buttons or small text areas where block elements break layout.
     */
    inline?: boolean;
}

export const RichTextRenderer = ({ html, className, inline = false, ...props }: RichTextRendererProps) => {
    if (!html) return null;

    return (
        <div
            className={cn(
                "rich-text-content",
                // Reset standard paragraph margins for tighter control
                "[&_p]:m-0 [&_p]:leading-relaxed",
                // If inline, ensure paragraphs display inline or similar to avoid breaking flow
                inline && "[&_p]:inline [&_div]:inline",
                className
            )}
            dangerouslySetInnerHTML={{ __html: html }}
            {...props}
        />
    );
}
